import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitoashtavinayakdarshancab() {



const cardData = {
  keyword: " Mumbai to Ashtavinayak Darshan Cab ",

headingDescription: "Velocity Cab offers reliable and comfortable Mumbai to Ashtavinayak Darshan cabs, providing seamless and spiritually enriching travel to the eight revered Ganesha temples (Ashtavinayak) across Maharashtra. Our professional drivers, well‑maintained vehicles, and flexible pickup options ensure a smooth and hassle‑free journey from Mumbai to all eight temples. We offer customizable routes, transparent pricing with no hidden charges, and a fleet of air‑conditioned sedans, spacious SUVs, and luxury cars suitable for family groups, devotees, and spiritual travelers. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Mumbai to Ashtavinayak Darshan cab travel.",

topPlaces: [
  {
    title: "Shree Girijatmaj Ganpati (Lenyadri)",
    description: "Located near Junnar, Shree Girijatmaj Ganpati is one of the eight Ashtavinayak temples and is uniquely situated in a Buddhist cave on a rocky hillside. Travelers from Mumbai can take a cab to this spiritual site to climb the steps into the cave temple and offer prayers. The location offers scenic views of rugged terrain and a peaceful atmosphere, making it a significant stop on the Ashtavinayak Darshan circuit."
  },
  {
    title: "Shree Mayureshwar Ganpati (Morgaon)",
    description: "Shree Mayureshwar Ganpati in Morgaon is considered the starting point of the Ashtavinayak Yatra and is one of the most important Ganesha temples in Maharashtra. Cab travelers from Mumbai can seek blessings for a successful pilgrimage at this sacred shrine, which features stunning temple architecture and spiritual rituals. The temple’s cultural significance and devotional energy make it a must‑visit for devotees."
  },
  {
    title: "Shree Siddhivinayak Ganpati (Siddhatek)",
    description: "Shree Siddhivinayak Ganpati Temple in Siddhatek is perched on the banks of the Bhima River and is known for bestowing spiritual accomplishments. Travelers using Mumbai to Ashtavinayak Darshan cabs can drive through scenic countryside to reach this temple, participate in darshan, and enjoy the serene riverside ambiance. The climb to the temple and surrounding views add to the devotional experience."
  },
  {
    title: "Shree Ballaleshwar Ganpati (Pali)",
    description: "Shree Ballaleshwar Ganpati Temple at Pali is unique for its association with the devotee Ballal and is known for granting devotees their heart’s desires. Cab travelers from Mumbai can visit this sacred site, witness traditional worship ceremonies, and explore the temple’s serene surroundings. The temple’s history and spiritual significance make it a highlight of the Ashtavinayak pilgrimage."
  },
  {
    title: "Shree Varad Vinayak (Mahad)",
    description: "Shree Varad Vinayak Temple in Mahad is famous for its belief in granting boons and protection from troubles. Travelers from Mumbai can take a cab to this temple, participate in darshan, and enjoy the coastal scenery nearby. The temple’s tranquil environment and spiritual rituals make it a memorable stop on the Ashtavinayak Darshan journey."
  },
  {
    title: "Shree Chintamani Ganpati (Theur)",
    description: "Shree Chintamani Ganpati Temple in Theur is revered for relieving devotees of worries and granting peace of mind. Cab travelers from Mumbai can visit this spiritual site, take part in daily rituals, and enjoy the temple’s peaceful gardens and sacred ambiance. The route from Mumbai to Theur offers pleasant views of the Deccan Plateau and agricultural landscapes."
  },
  {
    title: "Shree Mahaganpati (Ranjangaon)",
    description: "Shree Mahaganpati Ganpati Temple in Ranjangaon is one of the largest Ganesha idols among the Ashtavinayak temples. Travelers using Ashtavinayak Darshan cabs from Mumbai can reach this temple via a scenic drive, participate in devotional ceremonies, and explore the bustling temple complex. The site’s rich history and spiritual significance draw devotees from across Maharashtra."
  },
  {
    title: "Shree Vighnahar Vinayak (Ozar)",
    description: "Shree Vighnahar Vinayak Temple in Ozar is celebrated for overcoming obstacles and granting relief from troubles. Cab travelers from Mumbai can include this temple in their Ashtavinayak journey, enjoy the peaceful desert‑like surroundings, and participate in spiritual rituals. The temple’s welcoming atmosphere and traditional ceremonies make it a meaningful last stop on the pilgrimage circuit."
  }
],



services: [
{
name: "Mumbai to Ashtavinayak Cab Package",
description: "Mumbai to Ashtavinayak cab package offers a complete spiritual journey covering all eight sacred Ganpati temples across Maharashtra. This package is specially designed for devotees who want a well-planned and peaceful darshan experience without travel stress. The route includes temples like Moreshwar, Siddhivinayak, Ballaleshwar, Varadvinayak, Chintamani, Girijatmaj, Vighnahar, and Mahaganpati. Professional drivers with experience in long-distance and temple routes ensure a safe and smooth journey throughout the yatra. Comfortable AC vehicles with spacious seating make long travel hours relaxing for families and groups. Flexible itineraries allow proper darshan time, meal stops, and rest breaks during the journey. With transparent pricing and easy booking options, this cab package ensures a divine, comfortable, and hassle-free pilgrimage experience from Mumbai."
},
{
name: "Ashtavinayak Darshan Taxi from Mumbai",
description: "Ashtavinayak darshan taxi from Mumbai provides a convenient and reliable travel option for visiting all eight Ganpati temples in a single or multi-day trip. This service is ideal for devotees who prefer private transportation over crowded group tours. Experienced drivers ensure proper route planning to cover all temples efficiently while maintaining comfort and safety. Travelers can enjoy door-to-door pickup and drop service, avoiding the hassle of public transport. Multiple vehicle options including sedan, SUV, and tempo travellers are available based on group size. With easy booking and flexible schedules, this service offers a peaceful and well-organized spiritual journey."
},
{
name: "Mumbai Ashtavinayak Yatra Cab",
description: "Mumbai Ashtavinayak yatra cab service offers a dedicated travel solution for devotees planning a sacred Ganpati pilgrimage. This service ensures smooth travel across all temple locations with experienced drivers familiar with religious routes. Comfortable vehicles and flexible travel plans allow travelers to complete darshan at their own pace. It is ideal for families, senior citizens, and groups seeking a relaxed journey. Safe driving and proper rest halts enhance the overall experience. This cab service ensures a spiritually fulfilling and comfortable yatra."
},
{
name: "Mumbai to Ashtavinayak Tour by Cab",
description: "Mumbai to Ashtavinayak tour by cab provides a well-structured travel plan covering all temples with ease and comfort. Travelers can enjoy scenic routes, peaceful temple visits, and convenient travel arrangements throughout the journey. Professional drivers ensure timely arrival at each temple while maintaining safety standards. Flexible pickup options and customizable itineraries make this service highly convenient. It is suitable for both short trips and extended pilgrimage plans. This service offers a complete travel solution for devotees."
},
{
name: "Ashtavinayak Darshan Cab Booking Mumbai",
description: "Ashtavinayak darshan cab booking Mumbai allows travelers to easily reserve their pilgrimage cab with instant confirmation and flexible scheduling. Customers can select their preferred vehicle type and travel plan based on their needs. Transparent pricing ensures no hidden costs during the journey. Online booking options make the process quick and hassle-free. Dedicated customer support is available for assistance before and during the trip. It is the most convenient way to plan your Ashtavinayak yatra."
},
{
name: "Mumbai Ashtavinayak Taxi Package",
description: "Mumbai Ashtavinayak taxi package offers a complete travel solution including route planning, vehicle arrangement, and experienced drivers for a smooth pilgrimage. This package is ideal for travelers who want a fixed itinerary with comfortable travel options. Well-maintained vehicles ensure safety and reliability throughout the journey. Flexible timing allows proper darshan at each temple without rush. It is suitable for families, groups, and corporate spiritual trips. This package ensures a hassle-free and organized yatra experience."
},
{
name: "Mumbai to Ashtavinayak Outstation Cab",
description: "Mumbai to Ashtavinayak outstation cab service provides long-distance travel with comfort and safety for temple visits. This service is designed for multi-day journeys covering all eight temples efficiently. Experienced drivers ensure safe driving across highways and rural routes. Travelers can enjoy door-to-door pickup and flexible travel schedules. Multiple vehicle options are available for different group sizes. This service ensures a smooth and comfortable pilgrimage journey."
},
{
name: "Private Cab for Ashtavinayak Yatra",
description: "Private cab for Ashtavinayak yatra offers a personalized travel experience with exclusive vehicle usage for families and groups. Travelers can customize their route, stops, and travel duration based on their preferences. This ensures a relaxed and stress-free journey without time restrictions. Professional drivers provide safe and reliable service throughout the trip. Comfortable seating and clean vehicles enhance the travel experience. It is the best choice for a private and peaceful yatra."
},
{
name: "AC Cab Ashtavinayak Darshan Mumbai",
description: "AC cab Ashtavinayak darshan Mumbai ensures a comfortable journey in air-conditioned vehicles during long-distance travel. This service is ideal for all weather conditions, providing a relaxed and pleasant environment inside the vehicle. Well-maintained AC systems and clean interiors enhance passenger comfort. Suitable for families and senior citizens. Flexible pickup options add convenience to the journey. It ensures a comfortable and enjoyable darshan experience."
},
{
name: "Cheap Ashtavinayak Cab Package",
description: "Cheap Ashtavinayak cab package provides budget-friendly travel options for devotees without compromising on safety and comfort. This service is ideal for cost-conscious travelers looking for reliable transportation. Well-maintained vehicles and professional drivers ensure a smooth journey. Transparent pricing and no hidden charges make it a popular choice. Economical vehicle options are available for small groups. It is a perfect balance of affordability and comfort."
},
{
name: "Mumbai Ashtavinayak Temple Tour Taxi",
description: "Mumbai Ashtavinayak temple tour taxi offers a complete pilgrimage experience covering all eight temples with proper route planning and comfortable travel. Travelers can enjoy peaceful darshan and scenic travel across Maharashtra. Professional drivers ensure timely service and safe driving. Flexible itineraries allow convenient temple visits and rest stops. It is suitable for families, groups, and senior citizens. This service ensures a fulfilling and organized temple tour."
},
{
name: "Mumbai to Ashtavinayak Cab Fare",
description: "Mumbai to Ashtavinayak cab fare provides transparent pricing based on travel distance, vehicle type, and trip duration. Customers receive clear cost details to plan their journey budget effectively. Affordable fare options are available for sedan, SUV, and larger vehicles. No hidden charges ensure trust and reliability. Flexible pricing plans are available for one way and round trip packages. This helps travelers choose the best option for their pilgrimage."
}
],

tableData: [
["Mumbai to Ashtavinayak Cab Package","Ashtavinayak Darshan Taxi from Mumbai"],
["Mumbai Ashtavinayak Yatra Cab","Mumbai to Ashtavinayak Tour by Cab"],
["Ashtavinayak Darshan Cab Booking Mumbai","Mumbai Ashtavinayak Taxi Package"],
["Mumbai to Ashtavinayak Outstation Cab","Private Cab for Ashtavinayak Yatra"],
["AC Cab Ashtavinayak Darshan Mumbai","Cheap Ashtavinayak Cab Package"],
["Mumbai Ashtavinayak Temple Tour Taxi","Mumbai to Ashtavinayak Cab Fare"]
],



whychoose: [
  {
    WhyChooseheading: "Complete Ashtavinayak Darshan Package",
    WhyChoosedescription: "Velocity Cabs offers well-planned Mumbai to Ashtavinayak Darshan cab services covering all 8 Ganpati temples including Moreshwar, Siddhatek, Ballaleshwar, Varadvinayak, Chintamani, Girijatmaj, Vighnahar, and Mahaganpati for a peaceful spiritual journey."
  },
  {
    WhyChooseheading: "Experienced Pilgrimage Drivers",
    WhyChoosedescription: "Our drivers are experienced in temple routes and long-distance travel, ensuring safe driving, proper route planning, and a smooth darshan experience across all Ashtavinayak temples."
  },
  {
    WhyChooseheading: "Transparent Tour Pricing",
    WhyChoosedescription: "Velocity Cabs provides clear and transparent pricing for Ashtavinayak Darshan cab packages. Customers receive full details including travel cost, toll charges, and driver allowance with no hidden charges."
  },
  {
    WhyChooseheading: "Flexible Multi-Day Travel Plans",
    WhyChoosedescription: "We offer flexible travel plans for 1-day, 2-day, or 3-day Ashtavinayak Darshan tours based on customer preference and temple visit schedule."
  },
  {
    WhyChooseheading: "Comfortable AC Vehicles for Long Travel",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well maintained, and designed for long-distance journeys to provide maximum comfort during your spiritual trip."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for families and group pilgrimage travel."
  },
  {
    WhyChooseheading: "Doorstep Pickup from Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, railway stations, and airports across Mumbai for a smooth start to your Ashtavinayak Darshan."
  },
  {
    WhyChooseheading: "Trusted Pilgrimage Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many devotees for Mumbai to Ashtavinayak Darshan cab bookings due to reliable service, professional drivers, and comfortable travel experience."
  }
]
};

const faqData = [
  { question: "Do you provide Mumbai to Ashtavinayak Darshan cab service?", answer: "Yes, Velocity Cabs provides complete cab packages for Mumbai to Ashtavinayak Darshan covering all 8 temples." },
  { question: "Which temples are included in Ashtavinayak Darshan?", answer: "The darshan includes Moreshwar (Morgaon), Siddhatek, Ballaleshwar (Pali), Varadvinayak (Mahad), Chintamani (Theur), Girijatmaj (Lenyadri), Vighnahar (Ozar), and Mahaganpati (Ranjangaon)." },
  { question: "How many days are required for Ashtavinayak Darshan?", answer: "Typically, 1 to 3 days are required depending on the travel plan and temple visit schedule." },
  { question: "Which vehicles are available for the tour?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers." },
  { question: "Can I customize the Ashtavinayak tour package?", answer: "Yes, customers can customize the travel plan, number of days, and temple sequence as per their convenience." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 for flexible pilgrimage planning." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable long-distance travel." },
  { question: "Do you provide pickup from home or hotel?", answer: "Yes, we provide doorstep pickup from homes, hotels, railway stations, and airports across Mumbai." },
  { question: "Is advance booking required?", answer: "Yes, advance booking is recommended especially during weekends and festival seasons." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sagar Joshi",
    feedback:
      "A peaceful and well-planned Ashtavinayak Darshan trip from Mumbai. The cab was comfortable, the journey was smooth, and the entire experience felt spiritually fulfilling.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Radhika Kulkarni",
    feedback:
      "The Mumbai to Ashtavinayak Darshan tour was very well organized. The vehicle was clean, the ride was steady, and the overall pilgrimage experience was hassle-free and comfortable.",
    rating: 5
  }
];




























const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];












const mumbaiAshtavinayakJSON = {
  "@context": "https://schema.org",
  "@type": "TouristTrip",
  "name": "Mumbai to Ashtavinayak Darshan Cab | Velocity Cabs",
  "description": "Book a private cab from Mumbai for Ashtavinayak Darshan. Comfortable AC, Sedan, or SUV taxis available for outstation trips and one-day yatra packages.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Mumbai, Maharashtra, India"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Mumbai to Ashtavinayak Cab Packages",
    "itemListElement": [
      {
        "@type": "Offer",
        "name": "One-Day Ashtavinayak Darshan Cab from Mumbai",
        "description": "Private AC or Sedan cab from Mumbai for a full-day Ashtavinayak Yatra.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      },
      {
        "@type": "Offer",
        "name": "Ashtavinayak Outstation Cab Mumbai",
        "description": "Comfortable cab service for multi-day Ashtavinayak tour from Mumbai with AC/SUV options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      }
    ]
  }
};





  return (
    <div>
      

<Helmet>
  <title>Mumbai to Ashtavinayak Darshan Cab | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Book a private cab from Mumbai for Ashtavinayak Darshan. AC, Sedan, and SUV options available for one-day or multi-day yatra. Comfortable outstation taxi service from Mumbai."
  />
  <script type="application/ld+json">
    {JSON.stringify(mumbaiAshtavinayakJSON)}
  </script>
</Helmet>

 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/76.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitoashtavinayakdarshancab;